import type { AllergenDetection } from '@allergen-lens/shared-logic';
import type { SeverityLevel } from '@/types/profile';
import { Confidence } from '@allergen-lens/shared-logic';
import { categoryLabel } from '@allergen-lens/shared-logic';
import styles from './AllergenCard.module.css';

interface Props {
  detection: AllergenDetection;
  severity?: SeverityLevel;
}

const severityLabel: Record<SeverityLevel, string> = {
  must_avoid: 'Must Avoid',
  may_tolerate: 'May Tolerate',
  cross_contact_alert: 'Cross-Contact Alert',
};

function severityBadgeClass(severity: SeverityLevel): string {
  switch (severity) {
    case 'must_avoid': return styles.badgeMustAvoid ?? '';
    case 'may_tolerate': return styles.badgeMayTolerate ?? '';
    case 'cross_contact_alert': return styles.badgeCrossContact ?? '';
    default: return '';
  }
}

export function AllergenCard({ detection, severity }: Props) {
  const isReview = detection.confidence === Confidence.NeedsReview;
  const isCustom = detection.allergenCategory === 'custom';

  return (
    <div className={`${styles.card} ${isReview ? styles.cardReview : styles.cardPresent}`}>
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>{categoryLabel(detection.allergenCategory)}</span>
        <div className={styles.badges}>
          {isCustom && <span className={styles.customBadge}>Custom</span>}
          {severity && (
            <span className={`${styles.severityBadge} ${severityBadgeClass(severity)}`}>
              {severityLabel[severity]}
            </span>
          )}
          {isReview && <span className={styles.validateLabel}>Needs validation</span>}
        </div>
      </div>
      <div className={styles.triggerList}>
        <span className={styles.foundIn}>Found in:</span>
        {detection.triggeringIngredients.map((ing, i) => (
          <span key={i} className={styles.triggerTag}>{ing}</span>
        ))}
      </div>
    </div>
  );
}
